RivalIQ.module('views', function (views, App, Backbone, Marionette, $, _) {
    'use strict';

    views.DualGraphLegend = Marionette.CollectionView.extend({
        childView: views.DualGraphLegendItem
    });
});
